import styled, { keyframes } from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  height: calc(100% - 107px);
  background: var(--white);
  padding: 0 3%;
  overflow: auto;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    h1 {
      color: var(--blueDark);
    }

    > div {
      display: flex;
      flex-direction: column;
      text-align: right;
      font-weight: 500;
    }
  }

  .button {
    background: var(--yellowDark);
    color: var(--blueDark);
    border-radius: 10px;
    padding: 5px 10px;
    margin-top: 30px;
    margin-bottom: 15px;
    font-weight: bold;
    box-shadow: 2px 2px 2px rgba(12, 13, 14, 0.15);
    transition: background 0.2s;

    &:hover {
      background: ${darken(0.06, '#f7c325')};
    }
  }

  .request {
    display: flex;
    flex-direction: row-reverse;
  }

  .viewads {
    display: none;
    button {
      margin-top: 10px;
    }
  }

  .buttonMyAdss {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  margin: 5px 0;
  
  border-radius: 10px;
  font-weight: bold;

  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--grayLight);
    border: 1px solid var(--grayDark);
    border-radius: 5px 5px 1px 1px;
    padding: 0 20px;
    margin: -1px;
  }

  svg {
    cursor: pointer;
  }

  button {
    color: var(--blueDark);
    padding: 5px 15px;
    font-weight: bold;
    transition: background 0.2s;
    margin: 2px 0;

    &:hover {
      background: ${darken(0.02, '#fff')};
      border-radius: 10px;
    }
  }

  

  textarea {
    resize: none;
    border: 1px solid var(--grayDark);
    border-radius: 0 0 5px 5px;
    margin: -1px;
    padding: 5px;
  }

  input {
    width: 100%;
    height: 220px;
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 40px;

  > span {
    font-weight: bold;
    font-size: 25px;
    text-decoration: underline;
  }
`;

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const Loader = styled.div`
  border: 0.2em solid rgba(0, 0, 0, 0.1);
  border-top: 0.2em solid var(--grayDark);
  border-radius: 50%;
  width: 2.28571429rem;
  height: 2.28571429rem;
  animation: ${spin} 0.6s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  display: ${props => props.visible};
`;

export const InfoRequestSent = styled.div`
  margin-top: 10%;

  p {
    display: flex;
    justify-content: center;
    align-items: center;

    font-weight: bold;
    font-size: 1.2rem;
  }
`;
